import Link from "next/link";
import { PostData } from "pages/docs/[id]";

const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(" ");
};

interface RecentArticlesProps {
  allPostsData: PostData[];
}

const RecentArticles: React.FC<RecentArticlesProps> = ({ allPostsData }) => {
  // Note: the component name "RecentArticles" is currently a bit misleading, as these are being sorted not by date but by the filter below.
  // This component is currently working with a more skeletal set of content for a longer-term project that will include a full, distinct "docs" page
  // with its own navigation etc.  Markdown will migrate easily there, and this component can then be refactored for the support page to highlight featured or recent articles
  // as apporpriate

  const allPostsDataFeatured = allPostsData.filter(
    (post) => post.featured === "true"
  );

  return (
    <div className="bg-white pt-8 pb-20 px-4 sm:px-6 lg:pt-12 lg:pb-28 lg:px-8">
      <div className="relative max-w-lg mx-auto divide-y-2 divide-gray-200 lg:max-w-7xl">
        <div>
          <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
            Featured guides
          </h2>
          <p className="mt-3 text-xl text-gray-500 sm:mt-4">
            Learn more about specific topics as you form your startup using
            Symbola&apos;s tools.
          </p>
        </div>
        <div className="mt-12 grid gap-16 pt-12 lg:grid-cols-3 lg:gap-x-5 lg:gap-y-12">
          {allPostsDataFeatured.map((post: PostData) => (
            <div key={post.title}>
              <div>
                <div className="inline-block">
                  <span
                    className={`bg-${post.categoryColor}-100 text-${post.categoryColor}-800
                     inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium`}
                  >
                    {post.categoryName}
                  </span>
                </div>
              </div>
              <Link href={`docs/${post.id}`}>
                <a className="block mt-4">
                  <p className="text-xl font-semibold text-gray-900">
                    {post.title}
                  </p>
                  <p className="mt-3 text-base text-gray-500">
                    {post.description}
                  </p>
                </a>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default RecentArticles;
